import React from 'react';
import { Plugin } from 'prosemirror-state';

import { AddMenuVideo, VideoOutline } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import AllowForwardingDownloading from '../../../components/AllowForwardingDownloading';
import { addMenuItemType } from '../../../types/menus';
import { isAdvancedItemEnabled } from '../../../utils';
import { addAddMenuBlock, addAdvanceMenuItem } from '../../../utils/menus';
import Subtitle from '../components/Subtitle';
import Timestamps from '../components/Timestamps';
import { NODE_NAME } from '../consts';
import UppyVideoWrapper from './UppyVideoWrapper';

function plugins({ createReactNodeView, t, isMicroLearning }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          video(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              isMicroLearning,
              component: UppyVideoWrapper,
            });
          },
        },
      },
    }),

    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.video.title') as string,
            description: t('Lygo:Menu.video.description') as string,
            icon: VideoOutline,
            addMenuIcon: AddMenuVideo,
            addMenuItemType: addMenuItemType.media,
            attrs: { src: null, width: 75 },
            searchWords: ['video', 'media', 'upload'],
          },
        ]);

        addAdvanceMenuItem(editorView, {
          name: NODE_NAME,
          title: t('Lygo:AdvancedMenu.video.title'),
          components: [
            {
              name: 'allow_forwarding',
              component: (props) => (
                <AllowForwardingDownloading showDownload showPlaybackSpeedControls {...props} />
              ),
              isEnabled: isAdvancedItemEnabled,
            },

            {
              name: 'subtitle',
              component: Subtitle,
              isEnabled: isAdvancedItemEnabled,
            },
            {
              name: 'sections',
              component: Timestamps,
              isEnabled: isAdvancedItemEnabled,
            },
          ],
        });
        return {};
      },
    }),
  ];
}

export default plugins;
